/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Roles_TitleInputs */

const en_admin_roles_title = /** @type {(inputs: Admin_Roles_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Roles`)
};

const zh_admin_roles_title = /** @type {(inputs: Admin_Roles_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`角色管理`)
};

/**
* | output |
* | --- |
* | "Roles" |
*
* @param {Admin_Roles_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const admin_roles_title = /** @type {((inputs?: Admin_Roles_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Roles_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_roles_title(inputs)
	return zh_admin_roles_title(inputs)
});
export { admin_roles_title as "admin.roles.title" }